export enum UserRole {
    ADMIN = 'Admin',
    USER = 'User'
}
